import { FC } from "react";
import cx from "classnames";
import {
  ClientSiteData,
  PropertyData,
  PropertyVisualStyle,
  ShowIfNotSetValues,
  VehicleProperty,
} from "../../../types/site";
import { Vehicle } from "../../../types/vehicle";
import { Translations } from "../../../utils/translations";
import { vehiclePropertyFormatter, isPriceProperty } from "../../../utils/vehicleProperties";
import styles from "./vehicle-property-view.module.scss";
import { CustomTooltipType } from "./customTooltip/customTooltip";
import VehiclePropertyValue from "./vehicle-property-value-view";
import VehiclePropertyNameView from "./vehicle-property-name-view";

function getStyleObject(propertyVisualStyle: PropertyVisualStyle): Record<string, boolean> {
  return {
    [styles.finalPrice]: propertyVisualStyle === PropertyVisualStyle.FINAL_PRICE,
  };
}

interface IVehiclePropertyView {
  className: string;
  valueClassName: string;
  titleClassName: string;
  property: VehicleProperty;
  vehicle: Vehicle;
  siteData: ClientSiteData;
  showPrice: boolean;
  translations: Translations;
  callToPriceClassName: string;
  tooltipType?: CustomTooltipType;
}

const VehiclePropertyView: FC<IVehiclePropertyView> = ({
  className,
  valueClassName,
  property,
  vehicle,
  siteData,
  showPrice,
  translations,
  titleClassName,
  callToPriceClassName,
  tooltipType,
}) => {
  let propertyValue = vehiclePropertyFormatter(vehicle, property);

  let showIfNotSet = property.showIfNotSet || ShowIfNotSetValues.NOTHING;
  if (showIfNotSet === ShowIfNotSetValues.LOCKED && !property.lockText) {
    showIfNotSet = ShowIfNotSetValues.NOTHING;
  }
  if (isPriceProperty(property.visualStyle) && !showPrice) {
    if (propertyValue) {
      showIfNotSet = ShowIfNotSetValues.ALWAYS;
    }

    propertyValue = "";
  }

  const showProperty = propertyValue || showIfNotSet !== ShowIfNotSetValues.NOTHING;

  if (!showProperty) return null;

  if (property.data === PropertyData.SEPARATOR) {
    return <div className={cx(className, styles.separator)}></div>;
  }

  return (
    <div className={cx(className, getStyleObject(property.visualStyle))}>
      <VehiclePropertyNameView
        property={property}
        vehicle={vehicle}
        className={titleClassName}
        tooltipType={tooltipType}
      />
      <VehiclePropertyValue
        className={valueClassName}
        propertyName={property.name}
        propertyValue={propertyValue}
        vehicle={vehicle}
        siteData={siteData}
        translations={translations}
        callToPriceClassName={callToPriceClassName}
        visualStyle={property.visualStyle}
        showIfNotSet={showIfNotSet}
        lockText={property.lockText}
        lockTextLeftGradientColor={property.lockTextLeftGradientColor}
        lockTextRightGradientColor={property.lockTextRightGradientColor}
      />
    </div>
  );
};

export default VehiclePropertyView;
